import type React from "react";
import { ReactComponent as Svg } from "./assets/googleplay.svg";
import * as styles from "./Icon.module.scss";

type GooglePlayProps = React.SVGProps<SVGSVGElement>;

export const GooglePlay = ({ className, ...props }: GooglePlayProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
